import { render, staticRenderFns } from "./DimensionBoostAutobuyerBox.vue?vue&type=template&id=82133140&scoped=true"
import script from "./DimensionBoostAutobuyerBox.vue?vue&type=script&lang=js"
export * from "./DimensionBoostAutobuyerBox.vue?vue&type=script&lang=js"
import style0 from "./DimensionBoostAutobuyerBox.vue?vue&type=style&index=0&id=82133140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82133140",
  null
  
)

export default component.exports